// extracted by mini-css-extract-plugin
module.exports = {"root":"BmiRanges_root__1cGHr","ranges":"BmiRanges_ranges__plHaq"};